<template>
  <svg style="position: absolute; height: 0; width: 0">
    <filter :id="filterId">
      <feConvolveMatrix
        ref="convolveMatrix"
        :order="dimension"
        :kernelMatrix="kernel"
      />
    </filter>
  </svg>
</template>

<script>
export default {
  name: "FilterSharpen",
  components: {},
  data: function () {
    return {
      dimension: 1,
      kernel: 1,
      filterId: `filterSharpen-${(~~(Math.random() * 1e8)).toString(16)}`,
    };
  },
  props: {
    mSize: {
      type: Number,
      required: false,
      default: 5,
    },
    amount: {
      type: Number,
      required: true,
      //default: 1.0
    },
  },
  watch: {
    amount: function () {
      this.updateFilter();
    },
    mSize: function () {
      this.updateFilter();
    },
  },
  created() {
    //this.filterId = `filterSharpen-${(~~(Math.random() * 1e8)).toString(16)}`;
  },
  mounted() {
    this.updateFilter();
  },
  methods: {
    updateFilter() {
      this.dimension = this.mSize;
      const halfDimension = Math.floor(this.dimension / 2.0);
      const centerMatrixIndex = halfDimension * this.dimension + halfDimension;
      this.kernel = this.getKernel(this.dimension, 1.0);
      for (let i = 0; i < this.kernel.length; i++) {
        if (i == centerMatrixIndex) {
          this.kernel[i] = (this.kernel[i] - 1.0) * this.amount - 1.0;
        } else {
          this.kernel[i] *= this.amount;
        }
      }
    },
    getDistance(x1, y1, x2, y2) {
      const deltaX = x1 - x2;
      const deltaY = y1 - y2;
      return Math.sqrt(deltaX * deltaX + deltaY * deltaY);
    },
    getKernel(dimension, sigma) {
      let kernel = [];
      const twoSigmaSquare = 2.0 * sigma * sigma;
      const center = (dimension - 1) / 2;
      for (let i = 0; i < dimension; i++) {
        for (let j = 0; j < dimension; j++) {
          const x = this.getDistance(i, j, center, center);
          const gaussian =
            Math.exp(-(x * x) / twoSigmaSquare) /
            Math.sqrt(Math.PI * twoSigmaSquare);
          kernel.push(gaussian);
        }
      }
      let sum = kernel.reduce((c, p) => c + p);
      kernel = kernel.map((e) => e / sum);
      return kernel;
    },
  },
};
</script>

<style lang="scss">
</style>
